module.exports = __webpack_public_path__ + "img/forecast-logo-light.378a5c16.png";